module.exports = __webpack_public_path__ + "static/img/career2.c539747.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/career2.jpg
// module id = aSBy
// module chunks = 1